import ViewUIPlus, { Select, DatePicker, ColorPicker } from 'view-ui-plus'

const handlers = [
  { method: 'onClickOutside', original: Select.methods.onClickOutside, kind: 'select' },
  { method: 'handleClose', original: DatePicker.mixins[0].methods.handleClose, kind: 'date' },
  { method: 'handleClose', original: ColorPicker.methods.handleClose, kind: 'color' },
]

export default {
  install(app) {
    // Outside handlers must run after the clicked control receives its event.
    app.use(ViewUIPlus, { capture: false })
    app.mixin({
      created() {
        const handler = handlers.find(item => this.$options.methods?.[item.method] === item.original)
        if (!handler) return
        const original = this[handler.method]
        this[handler.method] = event => {
          const popup = handler.kind === 'select' ? this.$refs.dropdown?.$refs.drop
            : handler.kind === 'date' ? this.$refs.pickerPanel?.$el : this.$refs.drop?.$refs.drop
          // Keep selection, transferred/nested panels, dragging and keyboard behavior intact.
          if (!event || !['click', 'mousedown', 'touchstart'].includes(event.type)
            || !this.visible || this.$el.contains(event.target) || popup?.contains(event.target)
            || this.dragging) return original(event)
          // Do not cancel the next control's native focus or its compatibility click.
          if (event.type === 'mousedown') return
          if (handler.kind === 'select') {
            this.hideMenu()
            this.caretPosition = -1
            this.isFocused = false
          } else {
            this.visible = false
            if (handler.kind === 'date') {
              this.isFocused = false
              this.disableCloseUnderTransfer = false
              this.disableClickOutSide = false
            }
          }
          if (handler.kind !== 'color') this.$emit('on-clickoutside', event)
        }
      },
    })
  },
}
